import React, {Component, ChangeEvent} from "react"

import "react-toggle/style.css"

import newId from "@irati/utils/id"

import IconText from "../../IconText"
import Flex from "../../Flex"
import theme from "../../global/theme"

import {IconTypes} from "../../Icon"
import {StyledLabel, StyledLoader, StyledToggle} from "./styled"
import Load from "../utils/Load"

export type ToggleOnClick = (checked: boolean) => void

export interface ToggleProps {
  checked?: boolean
  disabled?: boolean
  icons?: () => void
  hint?: string
  label?: string
  load?: Promise<any>
  loader?: JSX.Element
  toggleColor?: string
  onClick: ToggleOnClick
}

interface State {
  checked?: boolean
  loaded?: boolean
}

class UIToggle extends Component<ToggleProps, State> {
  static defaultProps: Omit<ToggleProps, "onClick"> = {
    loader: <StyledLoader color="white" />,
    checked: false,
    disabled: false,
    // default is undefined so we default to react-toggle icons. Use false to hide
    icons: undefined
  }

  constructor(props: ToggleProps) {
    super(props)
    // create state for loader
    this.state = {
      checked: props.checked
    }
  }

  loader?: Load

  componentDidMount() {
    this.loader = new Load(this)
  }

  componentWillUnmount() {
    if (this.loader) this.loader.destroy()
  }

  UNSAFE_componentWillReceiveProps(nextProps: ToggleProps) {
    if (this.loader) this.loader.update(nextProps)

    if (nextProps.checked !== this.state.checked) {
      this.setState({checked: nextProps.checked})
    }
  }

  getLoadingIcons = () => {
    const {loaded} = this.state
    const {loader, checked, icons} = this.props

    if (loaded) {
      // user default toggle icons
      return icons
    }

    if (checked) {
      return {checked: loader, unchecked: null}
    }
    return {unchecked: loader, checked: null}
  }

  handleClick = (event: ChangeEvent<HTMLInputElement>) => {
    const {loaded} = this.state
    const {onClick} = this.props
    if (loaded) {
      const {checked} = event.target
      this.setState({checked}, () => {
        onClick(checked)
      })
    } else {
      this.setState({checked: this.state.checked})
    }
  }

  render() {
    const {onClick, label, hint, disabled, ...props} = this.props
    const {checked, loaded} = this.state

    const id = newId("toggle", this.props)
    const shouldDisable = !loaded || disabled
    const toggleColor = props.toggleColor || theme.colors.perkbox.blue

    return (
      <>
        <Flex alignItems="center">
          {label && (
            <StyledLabel bold htmlFor={id}>
              {label}
            </StyledLabel>
          )}
          <StyledToggle
            {...props}
            togglecolor={toggleColor}
            id={id}
            disabled={shouldDisable}
            icons={this.getLoadingIcons()}
            checked={checked}
            onClick={this.handleClick}
            aria-label="Toggle"
          />
        </Flex>
        {hint && (
          <IconText icon={IconTypes.info} id={newId("copy-hint", id)} small marginTop={1}>
            {hint}
          </IconText>
        )}
      </>
    )
  }
}

export default UIToggle
